// Shared marker for the executive dashlets' "good outcome" status note.
//
// The producer (`dashlets/executive/executive_dashlets.js`) and the consumer
// (`helpers/ai_explain.js`, which excludes good notes from the "items to
// review" count) import this constant so the wording cannot drift apart.
export const EXPLAIN_GOOD_STATUS_PREFIX = "Status was GOOD for ";

export function isGoodStatusIssue(issue) {
    return String(issue || "").startsWith(EXPLAIN_GOOD_STATUS_PREFIX);
}
